<template>
    <div class="zfErrWrap">
        <div class="zfErrCon">
            <img src="../assets/err.png" alt="">
            <h2>支付失败</h2>
            <button>返回首页</button>
            <!-- <marquee class="marquee" direction="down">
                <p>我是第一条</p>
                <p>我是第二条</p>
                <p>我是第三条</p>
                <p>我是第四条</p>
                <p>我是第五条</p>
                <p>我是第六条</p>
            </marquee> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            time: 6
        }
    },
    mounted() {
        // var html = ""
        // var that = this
        // setInterval(function () {
        //     that.time++
        //     // console.log(that.time)
        //     html = '<p>我是'+ that.time +'</p>'
        //     $('.marquee').prepend(html)
        // }, 1000);

    },
    methods: {

    }
}
</script>
<style lang="sass" scoped>
.marquee
    width: 2rem;
    height: 2rem;
    background: #fcc;
.zfErrWrap
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
    .zfErrCon
        position: absolute;
        width: 2.5rem;
        height: auto;
        top: 1rem;
        left: 50%;
        transform: translate(-50%, 0);
        img
            width: 0.8rem;
            height: 0.8rem;
            border-radius: 50%;
            display: block;
            margin: 0 auto;
        h2
            font-size: 0.17rem;
            font-weight: bolder;
            text-align: center;
            margin-top: 0.1rem;
        button
            width: 0.9rem;
            height: 0.25rem;
            font-size: 0.12rem;
            color: #fff;
            border: 0;
            outline: 0;
            border-radius: 0.03rem;
            display: block;
            background: #169BD5;
            margin: 0 auto;
            margin-top: 0.15rem;
</style>


// WEBPACK FOOTER //
// src/page/zfErr.vue